module.exports = __webpack_public_path__ + "media/images/dashboards/antibiotics-670a87d0b03e4973d4b7cfda5df09c75.png";